import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Player from '@vimeo/player'
import api from '@/handler/axios'
import firebase from "firebase/app"
import VueBus from 'vue-bus'
import Vuelidate from 'vuelidate'
 
Vue.use(VueBus, Vuelidate);
Vue.config.productionTip = false

Vue.prototype.$api = api

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyBAi68fJJJaSuLQ1irBIHZU7TuvJbHQs9s",
  authDomain: "sajilo-class.firebaseapp.com",
  databaseURL: "https://sajilo-class-default-rtdb.firebaseio.com",
  projectId: "sajilo-class",
  storageBucket: "sajilo-class.appspot.com",
  messagingSenderId: "326733764220",
  appId: "1:326733764220:web:493553b844ff17b4d11bf9",
  measurementId: "G-5REJ6ZK4NV"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);



router.beforeEach((to, from, next) => {
  if (to.meta.authentication) {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && Object.keys(user).length > 0) {
      next()
    } else {
      next('/')
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  vuetify,
  Player,
  render: h => h(App)
}).$mount('#app')
